import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import ExpandedIntegration from "components/ExpandedIntegration";
import { useSelector } from "react-redux";

function Integrations() {
  const navigate = useNavigate();
  const { integration } = useParams();
  const modules = useSelector((state) => state.modules.enabledModules);

  useEffect(() => {
    if (!integration) navigate("/settings?selectedTab=integrations", { replace: true });

    if (integration?.toLowerCase() === "tremendous") return;

    const integrationsModule = modules?.find(
      (moduleObject) => moduleObject?.Module?.module_name === "Integrations"
    );

    const requestedIntegrationToLower = integration?.toLowerCase();

    const matchedIntegrationModuleComponent = integrationsModule?.Module?.ModulesComponents?.find(
      (modulesComponent) => {
        const modulesComponentsToLoweredJoined = modulesComponent?.component_name
          ?.toLowerCase()
          ?.replace?.(" ", "_");

        return modulesComponentsToLoweredJoined === requestedIntegrationToLower;
      }
    );

    if (!matchedIntegrationModuleComponent || !matchedIntegrationModuleComponent.enabled)
      navigate("/settings?selectedTab=integrations", { replace: true });
  }, [integration, modules]);

  return (
    <DashboardLayout>
      {/* header */}
      <DashboardNavbar />
      <MDBox py={3} className="competition-form-wrapper">
        <Grid container justifyContent="center" alignItems="center">
          <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
            <ExpandedIntegration
              key={`${integration}-expanded-integration`}
              integrationName={integration?.replaceAll("_", " ")}
            />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Integrations;
